import React from 'react';
import ReactDOM from 'react-dom';
import _ from 'lodash';
import moment from 'moment';
import DateTimeField from '../../bootstrap-datetimepicker';
import HtmlUtil from '../../../utils/HtmlUtils';
import TransactionsStoreNew from '../../../stores/TransactionsStoreNew';
import TransactionsActionCreator from '../../../actions/TransactionsActionCreator';
import { Dropdown, MenuItem } from 'react-bootstrap';

let localDate = [];
let propsDate = [];
// todo fix this
let fromDate = moment().subtract(3, 'months'); // eslint-disable-line
let fromDateCssClass = 'c-field';
let fromDateErrorType = '';
let toDateCssClass = 'c-field';
let toDateErrorType = '';
let userTyping = false;

const monthNames = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

class Filter extends React.Component {
  constructor(props) {
    super(props);
    this.selectData = this.selectData.bind(this);
    this.onDropDownTogle = this.onDropDownTogle.bind(this);
    this.selectOption = this.selectOption.bind(this);
    this.onToDateChildClick = this.onToDateChildClick.bind(this);
    this.onFromDateChildClick = this.onFromDateChildClick.bind(this);
    this.onFromDateCloseClick = this.onFromDateCloseClick.bind(this);
    this.onToDateCloseClick = this.onToDateCloseClick.bind(this);
    this.fromDateChange = this.fromDateChange.bind(this);
    this.toDateChange = this.toDateChange.bind(this);
    this.fromDateFocus = this.fromDateFocus.bind(this);
    this.fromDateBlur = this.fromDateBlur.bind(this);
    this.toDateFocus = this.toDateFocus.bind(this);
    this.toDateBlur = this.toDateBlur.bind(this);
    this.dateValidation = this.dateValidation.bind(this);
    this.hasFocusFunc = this.hasFocusFunc.bind(this);
    this.changeCalenderIndex = this.changeCalenderIndex.bind(this);
    this.changeCalenderIndexForFrom =
      this.changeCalenderIndexForFrom.bind(this);
    this.applyFilterClick = this.applyFilterClick.bind(this);
    this.checkConditionForApllyFilter =
      this.checkConditionForApllyFilter.bind(this);
    this.state = {
      monthName: '3 months',
      select: 'all',
      eventKey: 0,
      date: moment(),
      format: 'DD MMM YY',
      fromFormat: 'DD MMM YY',
      inputFormat: 'DD MMM YY',
      fromInputFormat: 'DD MMM YY',
      mode: 'date',
      minDate: moment().subtract(60, 'months').add(1, 'second'),
      maxDate: moment().endOf('day'),
      when: moment().format('YYYY-MM-DD'),
      customDateSelected: false,
      fromDateValidationFlag: true,
      toDateValidationFlag: true,
      toDateFocusFlag: false,
      fromDateFocusFlag: false,
      calenderStyles: '',
      calenderStylesForFrom: '',
      applyFilterButtonFlag: false,
    };
  }

  componentWillMount() {
    localDate = this.props.date;
    this.setState({ localDate });
  }

  componentDidMount() {
    this.fromDateId = HtmlUtil.generateComponentId('date');
    this.toDateId = HtmlUtil.generateComponentId('date');
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.accountIdFromStore !== nextProps.accountIdFromStore) {
      this.setState(
        {
          minDate: moment().subtract(60, 'months'),
          maxDate: moment().endOf('day'),
          customDateSelected: false,
          fromDateValidationFlag: true,
          toDateValidationFlag: true,
          format: 'DD MMM YY',
          fromFormat: 'DD MMM YY',
          inputFormat: 'DD MMM YY',
          fromInputFormat: 'DD MMM YY',
          monthName: nextProps.monthName,
        },
        () => {}
      );
      fromDate = moment().endOf('day');
      this.refs['fromDateErr'].className = 'c-field';
      this.refs['fromMsgErr'].innerHTML = '';
      this.refs['toDateErr'].className = 'c-field';
      this.refs['toMsgErr'].innerHTML = '';
    }
  }

  onFromDateChildClick() {
    setTimeout(() => {
      ReactDOM.findDOMNode(
        this.refs.fromDatePicker
      ).children[0].addEventListener('click', this.onFromDateCloseClick);
    }, 100);
  }

  onToDateChildClick() {
    setTimeout(() => {
      ReactDOM.findDOMNode(this.refs.toDatePicker).children[0].addEventListener(
        'click',
        this.onToDateCloseClick
      );
    }, 100);
  }

  onFromDateCloseClick() {}

  onToDateCloseClick() {}

  onDropDownTogle(a, b, c) {
    this.setState({ dropdownOpen: a });
  }

  selectData(e) {
    propsDate = this.props.date;
    this.state.eventKey = e;
    this.setState({ monthName: propsDate[e].date });
  }

  selectMethod(e) {
    propsDate = this.props.date;
    this.state.eventKey = e;
    this.setState({ option: propsDate[e].date });
  }

  selectOption(key) {
    let startDate;
    let minimumDate;
    if (key !== 5) {
      switch (key) {
        case 0:
          this.setState({ monthName: '1 week' });
          startDate = moment(this.state.maxDate).startOf('day');
          startDate = startDate.subtract(1, 'week');
          minimumDate = moment().subtract(60, 'months').add(1, 'second');
          this.setState(
            { minDate: minimumDate, fromDateValidationFlag: true },
            () => {
              if (
                this.state.fromDateValidationFlag &&
                this.state.toDateValidationFlag
              ) {
                this.props.onDateChange(startDate, moment(this.state.maxDate));
              }
            }
          );
          this.props.settingMonthName('1 week');
          this.setState({ customDateSelected: false });
          fromDateCssClass = 'c-field';
          fromDateErrorType = '';
          this.refs['fromDateErr'].className = fromDateCssClass;
          this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
          break;
        case 1:
          this.setState({ monthName: '2 weeks' });
          startDate = moment(this.state.maxDate).startOf('day');
          startDate = startDate.subtract(2, 'week');
          minimumDate = moment().subtract(60, 'months').add(1, 'second');
          this.setState(
            { minDate: minimumDate, fromDateValidationFlag: true },
            () => {
              if (
                this.state.fromDateValidationFlag &&
                this.state.toDateValidationFlag
              ) {
                this.props.onDateChange(startDate, moment(this.state.maxDate));
              }
            }
          );

          this.props.settingMonthName('2 weeks');
          this.setState({ customDateSelected: false });
          fromDateCssClass = 'c-field';
          fromDateErrorType = '';
          this.refs['fromDateErr'].className = fromDateCssClass;
          this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
          break;
        case 2:
          this.setState({ monthName: '1 month' });
          startDate = moment(this.state.maxDate).startOf('day');
          startDate = startDate.subtract(1, 'months');
          minimumDate = moment().subtract(60, 'months').add(1, 'second');
          this.setState(
            { minDate: minimumDate, fromDateValidationFlag: true },
            () => {
              if (
                this.state.fromDateValidationFlag &&
                this.state.toDateValidationFlag
              ) {
                this.props.onDateChange(startDate, moment(this.state.maxDate));
              }
            }
          );
          this.props.settingMonthName('1 month');
          this.setState({ customDateSelected: false });
          fromDateCssClass = 'c-field';
          fromDateErrorType = '';
          this.refs['fromDateErr'].className = fromDateCssClass;
          this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
          break;
        case 3:
          this.setState({ monthName: '3 months' });
          startDate = moment(this.state.maxDate).startOf('day');
          startDate = startDate.subtract(3, 'months');
          minimumDate = moment().subtract(60, 'months').add(1, 'second');
          this.setState(
            { minDate: minimumDate, fromDateValidationFlag: true },
            () => {
              if (
                this.state.fromDateValidationFlag &&
                this.state.toDateValidationFlag
              ) {
                this.props.onDateChange(startDate, moment(this.state.maxDate));
              }
            }
          );
          this.props.settingMonthName('3 months');
          this.setState({ customDateSelected: false });
          fromDateCssClass = 'c-field';
          fromDateErrorType = '';
          this.refs['fromDateErr'].className = fromDateCssClass;
          this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
          break;
        case 4:
          this.setState({ monthName: '6 months' });
          startDate = moment(this.state.maxDate).startOf('day');
          startDate = startDate.subtract(6, 'months');
          minimumDate = moment().subtract(60, 'months').add(1, 'second');
          this.setState(
            { minDate: minimumDate, fromDateValidationFlag: true },
            () => {
              if (
                this.state.fromDateValidationFlag &&
                this.state.toDateValidationFlag
              ) {
                this.props.onDateChange(startDate, moment(this.state.maxDate));
              }
            }
          );
          this.props.settingMonthName('6 months');
          this.setState({ customDateSelected: false });
          fromDateCssClass = 'c-field';
          fromDateErrorType = '';
          this.refs['fromDateErr'].className = fromDateCssClass;
          this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
          break;
      }
    }
    if (key === 5) {
      fromDateCssClass = 'c-field';
      fromDateErrorType = '';
      this.props.settingMonthName('Custom');
      startDate = moment(this.state.maxDate).startOf('day');
      startDate = startDate.subtract(3, 'months');
      minimumDate = moment(this.state.maxDate).startOf('day');
      minimumDate = minimumDate.subtract(3, 'months').add(1, 'second');

      this.setState(
        {
          customDateSelected: true,
          monthName: 'Custom',
          minDate: minimumDate,
          fromDateValidationFlag: true,
          fromFormat: 'DD MMM YY',
          fromInputFormat: 'DD MMM YY',
        },
        () => {
          if (
            this.state.fromDateValidationFlag &&
            this.state.toDateValidationFlag
          ) {
            this.props.onDateChange(startDate, moment(this.state.maxDate));
          }
        }
      );
    }
  }

  fromDateChange(fromDateChanged) {
    let isValid;
    let fromDateChangedNew;
    let isUserTypes = false;
    // todo fix this
    let minimumDate; //eslint-disable-line
    let maximumDate;

    if (
      fromDateChanged === this.refs.fromDatePicker.state.inputValue &&
      _.includes(this.refs.fromDatePicker.state.inputValue, '/')
    ) {
      isUserTypes = true;
      isValid = this.fromDateValidation(
        this.refs.fromDatePicker.state.inputValue,
        'DD/MM/YYYY'
      );
    } else if (fromDateChanged !== 'Invalid date') {
      if (_.includes(fromDateChanged, '/')) {
        isValid = this.fromDateValidation(fromDateChanged, 'DD/MM/YYYY');
      } else {
        isValid = this.fromDateValidation(fromDateChanged, 'DD MMM YY');
      }
    } else {
      isValid = this.fromDateValidation(fromDateChanged, 'DD/MM/YYYY');
    }
    if (!isUserTypes) {
      document.getElementById('fromDatePickerId').focus();
    }
    if (isValid) {
      if (
        fromDateChanged === this.refs.fromDatePicker.state.inputValue &&
        _.includes(this.refs.fromDatePicker.state.inputValue, '/')
      ) {
        // User Types Date
        fromDateChangedNew = moment(
          this.refs.fromDatePicker.state.inputValue,
          'DD/MM/YYYY'
        );
        this.props.settingFromDate(
          moment(this.refs.fromDatePicker.state.inputValue, 'DD/MM/YYYY')
        );
        userTyping = true;
      } else {
        if (_.includes(fromDateChanged, '/')) {
          fromDateChangedNew = moment(fromDateChanged, 'DD/MM/YYYY');
          this.props.settingFromDate(moment(fromDateChanged, 'DD/MM/YYYY'));
        } else {
          fromDateChangedNew = moment(fromDateChanged, 'DD MMM YY');
          this.props.settingFromDate(moment(fromDateChanged, 'DD MMM YY'));
        }
        userTyping = false;
        this.setState({ applyFilterButtonFlag: false });
      }
      minimumDate = moment(fromDateChangedNew).add(1, 'second');
      maximumDate = moment(this.state.maxDate).endOf('day');
      this.setState(
        {
          fromDateValidationFlag: true,
          minDate: moment(fromDateChangedNew).add(1, 'second'),
          maxDate: maximumDate,
        },
        () => {}
      );
      if (userTyping) {
        this.setState({ applyFilterButtonFlag: true });
        TransactionsActionCreator.setApplyFilterStatus(true);
      }
    } else {
      this.setState({ fromDateValidationFlag: false });
    }
  }

  toDateChange(toDateChanged) {
    let isValid;
    let toDateChangedNew;
    let isUserTypes = false;
    let minimumDate;
    let maximumDate;
    if (
      toDateChanged === this.refs.toDatePicker.state.inputValue &&
      _.includes(this.refs.toDatePicker.state.inputValue, '/')
    ) {
      isUserTypes = true;
      isValid = this.dateValidation(
        this.refs.toDatePicker.state.inputValue,
        'DD/MM/YYYY'
      );
    } else if (toDateChanged !== 'Invalid date') {
      if (_.includes(toDateChanged, '/')) {
        isValid = this.dateValidation(toDateChanged, 'DD/MM/YYYY');
      } else {
        isValid = this.dateValidation(toDateChanged, 'DD MMM YY');
      }
    } else {
      isValid = this.dateValidation(toDateChanged, 'DD/MM/YYYY');
    }
    if (!isUserTypes) {
      document.getElementById('toDatePickerId').focus();
    }
    if (isValid) {
      if (
        toDateChanged === this.refs.toDatePicker.state.inputValue &&
        _.includes(this.refs.toDatePicker.state.inputValue, '/')
      ) {
        // User Types Date
        toDateChangedNew = moment(
          this.refs.toDatePicker.state.inputValue,
          'DD/MM/YYYY'
        );
        this.props.settingToDate(
          moment(this.refs.toDatePicker.state.inputValue, 'DD/MM/YYYY')
        );
        userTyping = true;
      } else {
        // User select date
        if (_.includes(toDateChanged, '/')) {
          toDateChangedNew = moment(toDateChanged, 'DD/MM/YYYY');
          this.props.settingToDate(moment(toDateChanged, 'DD/MM/YYYY'));
        } else {
          toDateChangedNew = moment(toDateChanged, 'DD MMM YY');
          this.props.settingToDate(moment(toDateChanged, 'DD MMM YY'));
        }
        userTyping = false;
        this.setState({ applyFilterButtonFlag: false });
      }

      let initialStartDate = this.props.startDate;
      let startDate = moment(toDateChangedNew).startOf('day');

      if (this.state.monthName === '1 week') {
        startDate = moment(startDate).subtract(1, 'week');
        initialStartDate = startDate;

        minimumDate = moment().subtract(60, 'months').add(1, 'second');
      } else if (this.state.monthName === '2 weeks') {
        startDate = moment(startDate).subtract(2, 'week');
        initialStartDate = startDate;

        minimumDate = moment().subtract(60, 'months').add(1, 'second');
      } else if (this.state.monthName === '1 month') {
        startDate = moment(startDate).subtract(1, 'months');
        initialStartDate = startDate;

        minimumDate = moment().subtract(60, 'months');
      } else if (this.state.monthName === '3 months') {
        startDate = moment(startDate).subtract(3, 'months').add(1, 'second');
        initialStartDate = startDate;

        minimumDate = moment().subtract(60, 'months');
      } else if (this.state.monthName === '6 months') {
        startDate = moment(startDate).subtract(6, 'months');
        initialStartDate = startDate;

        minimumDate = moment().subtract(60, 'months').add(1, 'second');
      } else {
        startDate = moment(startDate);
        initialStartDate = this.props.startDate;

        minimumDate = moment(this.props.startDate).add(1, 'second');
      }
      this.props.settingToDate(toDateChangedNew);
      this.props.settingFromDate(initialStartDate);

      maximumDate = moment(toDateChangedNew).endOf('day');
      if (userTyping) {
        this.setState({ applyFilterButtonFlag: true });
        TransactionsActionCreator.setApplyFilterStatus(true);
      }
      this.setState(
        {
          toDateValidationFlag: true,
          minDate: minimumDate,
          maxDate: maximumDate,
        },
        () => {}
      );
    } else {
      this.setState({ toDateValidationFlag: false });
    }
  }

  fromDateFocus() {
    this.refs.toDatePicker.closePicker();
    this.setState(
      {
        fromInputFormat: 'DD/MM/YYYY',
        fromFormat: 'DD/MM/YYYY',
        fromDateFocusFlag: true,
      },
      () => {
        if (
          this.state.fromDateValidationFlag &&
          this.state.toDateValidationFlag
        ) {
          if (this.props.fromChangeOfDate) {
            if (!userTyping) {
              document.getElementById('fromDatePickerId').blur();
              this.props.onDateChange(this.props.startDate, this.props.endDate);
            }
          }
        }
        if (!this.state.fromDateValidationFlag) {
          const localValidationFlag = this.fromDateValidation(
            this.refs.fromDatePicker.state.inputValue,
            'DD/MM/YYYY'
          );
          if (localValidationFlag) {
            this.setState({ fromDateValidationFlag: true }, () => {
              this.props.settingFromDate(
                moment(this.refs.fromDatePicker.state.inputValue, 'DD/MM/YYYY')
              );
            });
          }
        }
      }
    );
  }

  fromDateBlur() {
    if (
      this.fromDateValidation(
        this.refs.fromDatePicker.state.inputValue,
        'DD/MM/YYYY'
      )
    ) {
      this.setState(
        {
          fromInputFormat: 'DD MMM YY',
          fromFormat: 'DD MMM YY',
          fromDateValidationFlag: true,
          fromDateFocusFlag: false,
          calenderStylesForFrom: '',
        },
        () => {
          if (
            !this.state.fromDateFocusFlag &&
            this.state.monthName === 'Custom'
          ) {
            this.refs['fromDateErr'].className = fromDateCssClass;
            this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
          }
          if (!this.state.toDateValidationFlag) {
            const localValidationFlag = this.dateValidation(
              this.refs.toDatePicker.state.inputValue,
              'DD/MM/YYYY'
            );
            if (localValidationFlag) {
              this.props.settingToDate(
                moment(this.refs.toDatePicker.state.inputValue, 'DD/MM/YYYY')
              );
              if (!this.state.toDateFocusFlag) {
                this.refs['toDateErr'].className = toDateCssClass;
                this.refs['toMsgErr'].innerHTML = toDateErrorType;
              }

              this.setState(
                {
                  toDateValidationFlag: true,
                  inputFormat: 'DD MMM YY',
                  format: 'DD MMM YY',
                  maxDate: moment(
                    this.refs.toDatePicker.state.inputValue,
                    'DD/MM/YYYY'
                  ),
                },
                () => {
                  if (
                    this.state.fromDateValidationFlag &&
                    this.state.toDateValidationFlag
                  ) {
                    if (this.props.fromChangeOfDate) {
                      if (!userTyping) {
                        this.props.onDateChange(
                          this.props.startDate,
                          this.props.endDate
                        );
                      }
                    }
                  }
                }
              );
            }
          }
        }
      );
    } else {
      this.setState(
        { fromDateFocusFlag: false, calenderStylesForFrom: '' },
        () => {
          if (
            !this.state.fromDateFocusFlag &&
            this.state.monthName === 'Custom'
          ) {
            this.refs['fromDateErr'].className = fromDateCssClass;
            this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
          }
        }
      );
    }
  }

  toDateFocus() {
    if (this.state.monthName === 'Custom') {
      this.refs.fromDatePicker.closePicker();
    }
    this.setState(
      {
        inputFormat: 'DD/MM/YYYY',
        format: 'DD/MM/YYYY',
        toDateFocusFlag: true,
      },
      () => {
        if (
          this.state.fromDateValidationFlag &&
          this.state.toDateValidationFlag
        ) {
          if (this.props.changeOfDate) {
            if (!userTyping) {
              this.props.onDateChange(this.props.startDate, this.props.endDate);
              document.getElementById('toDatePickerId').blur();
            }
          }
        }
        if (!this.state.toDateValidationFlag) {
          const localValidationFlag = this.dateValidation(
            this.refs.toDatePicker.state.inputValue,
            'DD/MM/YYYY'
          );
          if (localValidationFlag) {
            this.setState({ toDateValidationFlag: true }, () => {
              this.props.settingToDate(
                moment(this.refs.toDatePicker.state.inputValue, 'DD/MM/YYYY')
              );
            });
          }
        }
      }
    );
  }

  toDateBlur() {
    if (
      this.dateValidation(this.refs.toDatePicker.state.inputValue, 'DD/MM/YYYY')
    ) {
      this.setState(
        {
          inputFormat: 'DD MMM YY',
          format: 'DD MMM YY',
          toDateFocusFlag: false,
          calenderStyles: '',
        },
        () => {
          if (!this.state.toDateFocusFlag) {
            this.refs['toDateErr'].className = toDateCssClass;
            this.refs['toMsgErr'].innerHTML = toDateErrorType;
          }
          if (!this.state.fromDateValidationFlag) {
            const localValidationFlag = this.fromDateValidation(
              this.refs.fromDatePicker.state.inputValue,
              'DD/MM/YYYY'
            );
            if (localValidationFlag) {
              this.props.settingFromDate(
                moment(this.refs.fromDatePicker.state.inputValue, 'DD/MM/YYYY')
              );
              if (
                !this.state.fromDateFocusFlag &&
                this.state.monthName === 'Custom'
              ) {
                this.refs['fromDateErr'].className = fromDateCssClass;
                this.refs['fromMsgErr'].innerHTML = fromDateErrorType;
              }
              this.setState(
                {
                  fromInputFormat: 'DD MMM YY',
                  fromFormat: 'DD MMM YY',
                  fromDateValidationFlag: true,
                  minDate: moment(
                    this.refs.fromDatePicker.state.inputValue,
                    'DD/MM/YYYY'
                  ),
                },
                () => {
                  if (
                    this.state.fromDateValidationFlag &&
                    this.state.toDateValidationFlag
                  ) {
                    if (this.props.changeOfDate) {
                      this.props.onDateChange(
                        this.props.startDate,
                        this.props.endDate
                      );
                    }
                  }
                }
              );
            }
          }
        }
      );
    } else {
      this.setState({ toDateFocusFlag: false, calenderStyles: '' }, () => {
        if (!this.state.toDateFocusFlag) {
          this.refs['toDateErr'].className = toDateCssClass;
          this.refs['toMsgErr'].innerHTML = toDateErrorType;
        }
      });
    }
  }

  dateValidation(recievedDateString, format) {
    let validationFlag = false;
    if (recievedDateString.length === format.length) {
      if (format === 'DD/MM/YYYY') {
        const sliptDate = recievedDateString.split('/');
        if (sliptDate.length === 3) {
          if (
            !_.isNaN(sliptDate[0]) &&
            !_.isNaN(sliptDate[1]) &&
            !_.isNaN(sliptDate[2])
          ) {
            validationFlag = true;
          } else {
            toDateCssClass = 'c-field c-field--error';
            toDateErrorType = this.props.content.chooseDateValidationMsg;
            return false;
          }
        } else {
          toDateCssClass = 'c-field c-field--error';
          toDateErrorType = this.props.content.chooseDateValidationMsg;
          return false;
        }
      } else if (format === 'DD MMM YY') {
        const sliptDate = recievedDateString.split(' ');
        if (sliptDate.length === 3) {
          if (
            !_.isNaN(sliptDate[0]) &&
            _.includes(monthNames, sliptDate[1]) &&
            !_.isNaN(sliptDate[2])
          ) {
            validationFlag = true;
          } else {
            toDateCssClass = 'c-field c-field--error';
            toDateErrorType = this.props.content.chooseDateValidationMsg;
            return false;
          }
        } else {
          toDateCssClass = 'c-field c-field--error';
          toDateErrorType = this.props.content.chooseDateValidationMsg;
          return false;
        }
      } else {
        toDateCssClass = 'c-field c-field--error';
        toDateErrorType = this.props.content.chooseDateValidationMsg;
        return false;
      }
    } else {
      toDateCssClass = 'c-field c-field--error';
      toDateErrorType = this.props.content.chooseDateValidationMsg;
      return false;
    }
    const recievedDate = moment(recievedDateString, format);
    if (this.state.monthName !== 'Custom') {
      if (recievedDate.isSameOrBefore(moment().endOf('day'))) {
        validationFlag = recievedDate.isBetween(
          moment().subtract(5, 'year').startOf('day'),
          moment().endOf('day'),
          null,
          '[]'
        );
        if (!validationFlag) {
          toDateCssClass = 'c-field c-field--error';
          toDateErrorType = this.props.content.todateRangeVallidationMsg;
          return false;
        }
      } else {
        toDateCssClass = 'c-field c-field--error';
        toDateErrorType = this.props.content.todateRangeVallidationMsg;
        return false;
      }
    } else {
      if (
        recievedDate.isSameOrAfter(moment(this.state.minDate).startOf('day'))
      ) {
        validationFlag = recievedDate.isBetween(
          moment().subtract(5, 'year').startOf('day'),
          moment().endOf('day'),
          null,
          '[]'
        );
        if (!validationFlag) {
          toDateCssClass = 'c-field c-field--error';
          toDateErrorType = this.props.content.todateRangeVallidationMsg;
          return false;
        }
      } else {
        toDateCssClass = 'c-field c-field--error';
        toDateErrorType = this.props.content.todateRangeVallidationMsg;
        return false;
      }
    }
    if (validationFlag) {
      toDateCssClass = 'c-field';
      toDateErrorType = '';
    }
    return validationFlag;
  }

  fromDateValidation(recievedDateString, format) {
    let validationFlag = false;
    if (recievedDateString.length === format.length) {
      if (format === 'DD/MM/YYYY') {
        const sliptDate = recievedDateString.split('/');
        if (sliptDate.length === 3) {
          if (
            !_.isNaN(sliptDate[0]) &&
            !_.isNaN(sliptDate[1]) &&
            !_.isNaN(sliptDate[2])
          ) {
            validationFlag = true;
          } else {
            fromDateCssClass = 'c-field c-field--error';
            fromDateErrorType = this.props.content.chooseDateValidationMsg;
            return false;
          }
        } else {
          fromDateCssClass = 'c-field c-field--error';
          fromDateErrorType = this.props.content.chooseDateValidationMsg;
          return false;
        }
      } else if (format === 'DD MMM YY') {
        const sliptDate = recievedDateString.split(' ');
        if (sliptDate.length === 3) {
          if (
            !_.isNaN(sliptDate[0]) &&
            _.includes(monthNames, sliptDate[1]) &&
            !_.isNaN(sliptDate[2])
          ) {
            validationFlag = true;
          } else {
            fromDateCssClass = 'c-field c-field--error';
            fromDateErrorType = this.props.content.chooseDateValidationMsg;
            return false;
          }
        } else {
          fromDateCssClass = 'c-field c-field--error';
          fromDateErrorType = this.props.content.chooseDateValidationMsg;
          return false;
        }
      } else {
        fromDateCssClass = 'c-field c-field--error';
        fromDateErrorType = this.props.content.chooseDateValidationMsg;
        return false;
      }
    } else {
      fromDateCssClass = 'c-field c-field--error';
      fromDateErrorType = this.props.content.chooseDateValidationMsg;
      return false;
    }
    const recievedDate = moment(recievedDateString, format);
    if (this.state.monthName !== 'Custom') {
      validationFlag = recievedDate.isBetween(
        moment().subtract(5, 'year').startOf('day'),
        moment().endOf('day'),
        null,
        '[]'
      );
    } else {
      if (
        recievedDate.isSameOrBefore(moment(this.state.maxDate).endOf('day'))
      ) {
        validationFlag = recievedDate.isBetween(
          moment().subtract(5, 'year').startOf('day'),
          moment(this.state.maxDate).endOf('day'),
          null,
          '[]'
        );
        if (!validationFlag) {
          fromDateCssClass = 'c-field c-field--error';
          fromDateErrorType = this.props.content.dateRangeVallidationMsg;
        }
      } else {
        fromDateCssClass = 'c-field c-field--error';
        fromDateErrorType = this.props.content.dateRangeVallidationMsg;
        validationFlag = false;
      }
    }
    if (validationFlag) {
      fromDateCssClass = 'c-field';
      fromDateErrorType = '';
    }
    return validationFlag;
  }

  hasFocusFunc(e) {}

  changeCalenderIndex() {
    this.setState({
      calenderStylesForFrom: '',
      calenderStyles: 'u-zindex--100',
    });
  }

  changeCalenderIndexForFrom() {
    this.setState({
      calenderStylesForFrom: 'u-zindex--100',
      calenderStyles: '',
    });
  }

  applyFilterClick() {
    if (this.state.fromDateValidationFlag && this.state.toDateValidationFlag) {
      if (this.props.changeOfDate) {
        this.props.onDateChange(this.props.startDate, this.props.endDate);
        this.setState({ applyFilterButtonFlag: false });
      } else if (this.props.fromChangeOfDate) {
        this.props.onDateChange(this.props.startDate, this.props.endDate);
        this.setState({ applyFilterButtonFlag: false });
      }
    }
  }

  checkConditionForApllyFilter() {
    const { content, fromChangeOfDate, changeOfDate } = this.props;
    const { applyFilterButtonFlag } = this.state;
    if (
      applyFilterButtonFlag &&
      fromChangeOfDate &&
      TransactionsStoreNew.getApplyFilterBtnstatus()
    ) {
      return (
        <button
          type="button"
          className="c-btn c-btn--default btn-size"
          onClick={this.applyFilterClick}
        >
          {content.applyFilter}
        </button>
      );
    } else if (
      applyFilterButtonFlag &&
      changeOfDate &&
      TransactionsStoreNew.getApplyFilterBtnstatus()
    ) {
      return (
        <button
          type="button"
          className="c-btn c-btn--default btn-size"
          onClick={this.applyFilterClick}
        >
          {content.applyFilter}
        </button>
      );
    }
  }

  render() {
    const { format, mode, inputFormat } = this.state;
    let fromFormat = this.state.fromFormat;
    let fromInputFormat = this.state.fromInputFormat;
    let endDateForToDatePicker = this.props.endDate;
    let startDateForFromDatePicker = this.props.startDate;
    const toDateInputProps = {
      id: 'toDatePickerId',
      onBlur: (e) => this.toDateBlur(e),
      onFocus: (e) => this.toDateFocus(e),
      'aria-invalid': 'false',
      'aria-live': this.toDateId,
    };
    toDateInputProps['aria-labelledby'] = this.toDateId;
    const fromDateInputProps = {
      id: 'fromDatePickerId',
      onBlur: (e) => this.fromDateBlur(e),
      onFocus: (e) => this.fromDateFocus(e),
      'aria-invalid': 'false',
      'aria-live': this.fromDateId,
    };
    fromDateInputProps['aria-labelledby'] = this.fromDateId;
    const dropDownList = [];
    _.map(localDate, (localdate, index) => {
      const dropDownComponent = (
        <MenuItem eventKey={index} onSelect={this.selectOption}>
          {localdate.date}
        </MenuItem>
      );
      dropDownList.push(dropDownComponent);
    });
    const customDateSelectedFlag = this.state.customDateSelected;
    let displayEditableFromCalender;
    let fromPara;
    if (customDateSelectedFlag) {
      displayEditableFromCalender = (
        <div
          className={`filter__choose-date ${this.state.calenderStylesForFrom}`}
          onClick={this.changeCalenderIndexForFrom}
          aria-label="From Date"
        >
          <div className="filter__menu-calender">
            <DateTimeField
              ref="fromDatePicker"
              maxDate={this.state.maxDate}
              minDate={moment().subtract(60, 'months')}
              dateTime={startDateForFromDatePicker}
              format={fromFormat}
              viewMode={mode}
              inputFormat={fromInputFormat}
              onChange={this.fromDateChange}
              inputProps={fromDateInputProps}
            />
          </div>
        </div>
      );
      fromPara = <p>from</p>;
    } else {
      displayEditableFromCalender = <div />;
      fromPara = <div />;
    }
    return (
      <div className="filter">
        <p id="showingLbl" aria-label="Transactions Showing">
          Showing
        </p>
        <div className="filter__options">
          <div className="btn-toolbar">
            <Dropdown
              className="custom-dropdown"
              onToggle={this.onDropDownTogle}
            >
              <Dropdown.Toggle
                noCaret
                aria-labelledby="showingLbl selectedText"
              >
                <span id="selectedText">{this.state.monthName}</span>
                <svg
                  className={'symbol '}
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path d="M19.55 12.602l1.884 1.833-5.717 5.565-5.717-5.565 1.883-1.833 3.833 3.731z" />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu>{dropDownList}</Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {fromPara}
        {displayEditableFromCalender}
        <p>to</p>
        <div
          className={`filter__choose-date ${this.state.calenderStyles}`}
          onClick={this.changeCalenderIndex}
          aria-label="To Date"
        >
          <div className="filter__menu-calender">
            <DateTimeField
              ref="toDatePicker"
              dateTime={endDateForToDatePicker}
              format={format}
              viewMode={mode}
              inputFormat={inputFormat}
              maxDate={moment()}
              minDate={this.state.minDate}
              onChange={this.toDateChange}
              inputProps={toDateInputProps}
            />
          </div>
        </div>
        {this.checkConditionForApllyFilter()}
        <div className="c-field" ref="fromDateErr">
          <div className="c-field__controls">
            <div
              className="c-field__message"
              id={this.fromDateId}
              ref="fromMsgErr"
              role="alert"
            />
          </div>
        </div>
        <div className="c-field" ref="toDateErr">
          <div className="c-field__controls">
            <div
              className="c-field__message"
              id={this.toDateId}
              ref="toMsgErr"
              role="alert"
            />
          </div>
        </div>
      </div>
    );
  }
}

export default Filter;
